<template>
    <div class="banner" ref="bannerContainer" v-show="items?.length">
        <div class="spinner-border text-primary" role="status" v-show="isLoading">
            <span class="sr-only">Loading...</span>
        </div>
        <div class="owl-carousel" v-show="!isLoading && items?.length" ref="carousel">
            <h4 v-for="item in items" :key="item.id">
                <a :href="item.href" class="index-banner" title=""
                   @click.prevent="handleClick($event, item.title,'homePage_slideBanner_bannerName')">
                    <img class="lazyload" :data-src="item?.Pics[0]?.url['w0h0'] ?? 'img/pic/no_image_icon.png'" alt="" :title="item.title">
                    <span class="banner-title" v-text="item.title"></span>
                </a>
            </h4>
        </div>
    </div>
</template>

<script>
import Datalayer from 'Controllers/Web/Datalayer';

export default {
    name: 'HomeBanner',
    props: {
        items: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            isLoading: true,
        };
    },
    mounted() {
        if (this?.items?.length > 0) {
            this.setupIntersectionObserver();
        } else {
            this.isLoading = false;
        }
    },
    methods: {
        async handleClick(event, title, position) {
            event.preventDefault();
            await Datalayer.storeDatalayerEvent(title, position);
            window.location.href = event.target.href;
        },
        setupIntersectionObserver() {
            const options = {
                root: null, // 代表 viewport
                threshold: 0.3, // 當元素進入到 30% 的範圍時觸發
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.initOwlCarousel();
                        observer.unobserve(this.$refs.bannerContainer); // 只觸發一次，然後停止觀察
                    }
                });
            }, options);

            if (this.$refs.bannerContainer) {
                observer.observe(this.$refs.bannerContainer);
            }
        },
        initOwlCarousel() {
            this.isLoading = false;
            $(this.$refs.carousel)
                .owlCarousel({
                    autoplay: true, // 自動撥放
                    autoplayTimeout: 6000,
                    autoplayHoverPause: true,
                    loop: true, // 圖片循環
                    center: false, // 是否置中
                    navText: [], // 箭頭預設文字消失
                    nav: false, // 前後箭頭
                    dot: true,
                    items: 1,
                });
        },
    },
};
</script>
<style scoped lang="scss">
.spinner-border {
    margin: 50px 50%;
}
</style>
